export default __webpack_public_path__ + "static/indastrial_main-722445f198fd07ac081465970504ccaf.jpg";